export default "__VITE_ASSET__CRDBmmpl__"